import axios from "axios"
import { AddAlert } from "../../components"
import { cicloIntervalo, idiomaString, paramsApi } from "../../helpers"
import api from "../../helpers/api"
import apiV3 from "../../helpers/apiV3"
import apiAuth from "../../helpers/apiAuth"
import apiOld from "../../helpers/apiOld"
import { history } from "../../helpers/history"
import listasJson from "./listas.json"
import apiIp from "../../helpers/apiIp"

import apiBase from "../../helpers/apiBase"
import { listarGruposEstabelecimentos, listarGruposProdutos, listarMeusProjetos, listarMeusProjetosEmpresas, listarMeusProjetosEstabelecimentos, listarMeusProjetosProdutos } from "../../modules/meusProjetos/redux/meusProjetosActions"
import { setProjetosFiltro } from "../../modules/projetos/redux/projetosActions"
const nls = require('../nls/pt-BR.json')


export const loading = e => ({
  type: 'LOADING',
  payload: true
})

export const loaded = e => ({
  type: 'LOADING',
  payload: false
})

export const getSistema = payload => ({
  type: 'GET_SISTEMA',
  payload
})

export const setDevice = payload => ({
  type: 'SET_DEVICE',
  payload
})

export const setHeigthPage = payload => ({
  type: 'SET_HEIGTH_PAGE',
  payload
})

export const getSistemaIdioma = payload => ({
  type: 'GET_SISTEMA_IDIOMA',
  payload
})

export const setSidebarLeft = e => ({
  type: 'SIDEBAR_LEFT',
  payload: e
})

export const setSidebarRigth = e => ({
  type: 'SIDEBAR_RIGHT',
  payload: e
})

export const modalOpen = payload => ({
  type: 'MODAL_OPEN',
  payload
})

export const modalClose = e => ({
  type: 'MODAL_OPEN',
  payload: ''
})

export const modalAlertaInfo = e => ({
  type: 'MODAL_ALERTA_INFO',
  payload: e
})

export const modalAlertaClean = e => ({
  type: 'MODAL_ALERTA_CLEAN',
  payload: ''
})

export const setTitlePage = e => ({
  type: 'TITLE_PAGE',
  payload: e
})

export const validacaoCampos = e => ({
  type: 'VALIDACAO',
  payload: e
})

export const setCarregarUsuarioLogado = e => ({
  type: 'USUARIO_LOGADO_CARREGAR',
  payload: e
})

export const setListarProjetos = e => ({
  type: 'LIST_PROJETOS',
  payload: e
})

export const setInfoProjeto = e => ({
  type: 'INFO_PROJETO',
  payload: e
})

export const setInfoCliente = e => ({
  type: 'INFO_CLIENTE',
  payload: e
})

export const setListarGrupos = e => ({
  type: 'LIST_GRUPOS',
  payload: e
})

export const setInfoGrupo = e => ({
  type: 'INFO_GRUPO',
  payload: e
})

export const setListarEmpresas = e => ({
  type: 'LIST_EMPRESAS',
  payload: e
})

export const setInfoEmpresa = e => ({
  type: 'INFO_EMPRESA',
  payload: e
})

export const setListarCategorias = e => ({
  type: 'LIST_CATEGORIAS',
  payload: e
})

export const setInfoCategoria = e => ({
  type: 'INFO_CATEGORIA',
  payload: e
})

export const setListarCiclos = payload => ({
  type: 'LIST_CICLOS',
  payload
})

export const setInfoCiclo = payload => ({
  type: 'INFO_CICLO',
  payload
})



export const setFilters = payload => ({
  type: 'INFO_FILTERS',
  payload
})

export const setFiltersHas = payload => ({
  type: 'INFO_FILTERS_HAS',
  payload
})

export const setFiltersActive = payload => ({
  type: 'INFO_FILTERS_ACTIVE',
  payload
})

export const cleanFilters = () => ({
  type: 'INFO_FILTERS_CLEAN',
})

export const setFiltered = payload => ({
  type: 'INFO_FILTERED',
  payload
})


export const setRecebePopupCriaEmpresa = (payload) => ({
  type: 'SET_RECEBE_POPUP_CRIA_EMPRESA',
  payload, // true/false
});

export const setRecebePopupCriaEstabelecimento = (payload) => ({
  type: 'SET_RECEBE_POPUP_CRIA_ESTABELECIMENTO',
  payload, // true/false
});

export const setRecebePopupVerificaEstabelecimento = (payload) => ({
  type: 'SET_RECEBE_POPUP_VERIFICA_ESTABELECIMENTO',
  payload, // true/false
});

export const setRecebePopupCriaProduto = (payload) => ({
  type: 'SET_RECEBE_POPUP_CRIA_PRODUTO',
  payload, // true/false
});


export const filteredItens = e => {
  return dispatch => {
    localStorage.setItem('filtered', JSON.stringify(e))
    dispatch(setFiltered(e))
  }
}




export const titlePage = ({pathname, menuItens}) => {
  return dispatch => {
    menuItens?.map(d=> {
      if (d.sub) {
        const activeItem = d.sub.filter(e=> pathname === e.go)
        if (activeItem.length) {
          dispatch(setTitlePage(activeItem[0].label))
        }
      } else {
        if (pathname.includes(d.go)) {
          dispatch(setTitlePage(d.label))
        }
      }
    })
  }
}



//CHAMADO PELA PÁGINA INTERNA DE VISUALIZAÇÃO DE CADA PROJETO QUANDO MUDA O PROJETO
export const setProjeto = (e, url='') => {
 

  const pathname = history.location.pathname.split('/')
  console.log("PARTE1-PATHNAME", pathname)
  //console.error(pathname, 'setProjetoxxxpathname');
  console.log("PARTE PATHNAME[2]",pathname[2] )

  //aqui trata o caso de ter sido chamado das páginas internas trocando o projeto
  if (pathname[2]) {
    console.log("PARTEINT PATHNAME ENTROU",pathname[2] )
    pathname[2] = e.id

    // Garante que o último segmento seja 'feedbacks'
  if (pathname.length > 3) {
    //pathname[3] = 'feedbacks';
    // Substitui o índice 3 e remove tudo que vem depois com na análise swot que tem /myprojects/2/swotanalysis/threat
    pathname.splice(3, pathname.length - 3, 'feedbacks');
  } else if (pathname.length === 3) {
    pathname.push('feedbacks');
  }

    let novaUrl = pathname.join('/'); // TIPO /myprojects/2/feedbacks
    //let novaUrl = pathname; ISSO PRECISA QUANDO É CHAMADO DE MEUSPROJETOS APENAS

    //console.error(novaUrl, 'setProjetopathname novaUrl');
    console.log("PARTE2INT-NOVAURL", novaUrl)
    console.log("PARTE2AINT-E", e)
    
    history.push(novaUrl)
  }
  else{ //AQUI SE FOR CHAMADO POR MEUSPROJETOS
    if(url){
      console.log("PARTE5-URL", url)
    history.push(url)
    }   
  }

  
  const cicloReturn = e.ciclos.map(c=> cicloIntervalo(c))

  return dispatch => dispatch([
    setFilters({name: 'categoria', value: {}}),
    setFilters({name: 'empresa', value: {}}),
    setFilters({name: 'ciclo', value: cicloReturn[0]}),
    
    detlaharProjeto(e),
    setListarCiclos(cicloReturn),
    setInfoCiclo(cicloReturn[0]),
    
    setListarCategorias(e.categorias),
    setInfoCategoria(e.categorias[0]),
        
  ])
    

}




export const setProjetoMeusProjetos = (e, url='') => {
  return async (dispatch) => { // Adicione async
    const pathname = history.location.pathname.split('/')
    
    if(url){
      history.push(url)
    }   

    const cicloReturn = e.ciclos.map(c=> cicloIntervalo(c))
    
    // Aguarda cada dispatch sequencialmente
    await dispatch(setFilters({name: 'categoria', value: {}}))
    await dispatch(setFilters({name: 'empresa', value: {}}))
    await dispatch(setFilters({name: 'ciclo', value: cicloReturn[0]}))
    
    await dispatch(detlaharProjeto(e)) // Este é o importante
    await dispatch(setListarCiclos(cicloReturn))
    await dispatch(setInfoCiclo(cicloReturn[0]))
    await dispatch(setListarCategorias(e.categorias))
    await dispatch(setInfoCategoria(e.categorias[0]))
  }
}


//CHAMADO PELA PÁGINA MEUSPROJETOS QUANDO MUDA O PROJETO
export const setProjetoMeusProjetosOLDX = (e, url='') => {
 

  const pathname = history.location.pathname.split('/')
  //console.log("PARTE1-PATHNAME", pathname)
    //console.log("PARTE PATHNAME[2]",pathname[2] )
 
    console.log("PROJETOABC",e )

    if(url){
      console.log("PARTE5-URL", url)
    history.push(url)
    }   

  
  const cicloReturn = e.ciclos.map(c=> cicloIntervalo(c))

  return dispatch => dispatch([
    setFilters({name: 'categoria', value: {}}),
    setFilters({name: 'empresa', value: {}}),
    setFilters({name: 'ciclo', value: cicloReturn[0]}),
    
    detlaharProjeto(e),
    setListarCiclos(cicloReturn),
    setInfoCiclo(cicloReturn[0]),
    
    setListarCategorias(e.categorias),
    setInfoCategoria(e.categorias[0]),
        
  ])
    

}

//CHAMADO PELA PÁGINA FEEDBACKS QUANDO SELECIONA OUTRO PROJETO NO COMBO PROJETOS
//FOI INCORPORADO NA LÓGICA DO SETPROJETO

/*
export const setProjetoInterno = (e, url='') => {
  //console.error(e, url, 'setProjetoxxx');


  const pathname = history.location.pathname.split('/')
  console.log("PARTE1INT-PATHNAME", pathname)
  //console.error(pathname, 'setProjetoxxxpathname');
  console.log("PARTEINT PATHNAME[2]",pathname[2] )
  if (pathname[2]) {
    console.log("PARTEINT PATHNAME ENTROU",pathname[2] )
    pathname[2] = e.id

    // Garante que o último segmento seja 'feedbacks'
  if (pathname.length > 3) {
    pathname[3] = 'feedbacks';
  } else if (pathname.length === 3) {
    pathname.push('feedbacks');
  }

    let novaUrl = pathname.join('/'); // TIPO /myprojects/2/feedbacks
    //let novaUrl = pathname; ISSO PRECISA QUANDO É CHAMADO DE MEUSPROJETOS APENAS

    //console.error(novaUrl, 'setProjetopathname novaUrl');
    console.log("PARTE2INT-NOVAURL", novaUrl)
    console.log("PARTE2AINT-E", e)
    
    history.push(novaUrl)
  } 
  
  const cicloReturn = e.ciclos.map(c=> cicloIntervalo(c))

  return dispatch => dispatch([
    setFilters({name: 'categoria', value: {}}),
    setFilters({name: 'empresa', value: {}}),
    setFilters({name: 'ciclo', value: cicloReturn[0]}),
    
    detlaharProjeto(e),
    setListarCiclos(cicloReturn),
    setInfoCiclo(cicloReturn[0]),
    
    setListarCategorias(e.categorias),
    setInfoCategoria(e.categorias[0]),
        
  ])
}

*/

export const detlaharProjeto = e => {
  return async (dispatch) => {
    if (e.temMenuEmpresa) {
      await dispatch(listarMeusProjetosEmpresas({ idProjeto: e.id }, false))
    }
    if (e.temMenuEstabelecimento) {
      await dispatch(listarMeusProjetosEstabelecimentos({ idProjeto: e.id }, false))
      await dispatch(listarGruposEstabelecimentos(e.id, false))
    }
    if (e.temMenuProduto) {
      await dispatch(listarMeusProjetosProdutos({ idProjeto: e.id }, false))
      await dispatch(listarGruposProdutos(e.id, false))
    }
  }
}



export const detlaharProjetoOLD33 = e => {
  return async (dispatch) => { // Adicione async
    if (e.temMenuEmpresa) {
      await dispatch(listarMeusProjetosEmpresas({idProjeto: e.id}))
    }
    if (e.temMenuEstabelecimento) {
      await dispatch(listarMeusProjetosEstabelecimentos({idProjeto: e.id}))
      await dispatch(listarGruposEstabelecimentos(e.id))
    }
    if (e.temMenuProduto) {
      await dispatch(listarMeusProjetosProdutos({idProjeto: e.id}))
      await dispatch(listarGruposProdutos(e.id))
    }
  }
}


export const detlaharProjetoOLDX = e => {
  console.error(e, 'DetlaharProjeto');

  return dispatch => { 
    if (e.temMenuEmpresa) {
      dispatch(listarMeusProjetosEmpresas({idProjeto: e.id}))
    }
    if (e.temMenuEstabelecimento) {
      dispatch(listarMeusProjetosEstabelecimentos({idProjeto: e.id}))
      dispatch(listarGruposEstabelecimentos(e.id))
    }
    if (e.temMenuProduto) {
      dispatch(listarMeusProjetosProdutos({idProjeto: e.id}))
      dispatch(listarGruposProdutos(e.id))
    }
  }
}


// export const setProjeto = e => {
 
//   const cicloReturn = e.ciclos.map(c=> cicloIntervalo(c))
//   const respGrupos = e.grupos.map((g, i)=> ({id: i, name: g.nomeGrupo?g.nomeGrupo:'grupo', ...g}))
  
//   localStorage.setItem('projetoINSV', JSON.stringify(e))
//   return dispatch => dispatch([
//     setInfoProjeto(e),
//     setListarGrupos(respGrupos),
//     setInfoGrupo(respGrupos[0]),
//     setListarCiclos(cicloReturn),
//     setInfoCiclo(cicloReturn[0]),

//     setListarEmpresas(e.empresas),
//     setInfoEmpresa(e.empresas[0]),
//     setFilters({name: 'empresa', value: {}}),
//     setFilters({name: 'categoria', value: {}}),

//     // setInfoCliente(e.cliente),
//     // setListarGrupos(e.grupos),
//     // setInfoGrupo(e.grupos[0]),
//     // setListarEmpresas(e.empresas),
//     // setInfoEmpresa(e.empresas[0]),
//     // setListarCategorias(e.categorias),
//     // setInfoCategoria(e.categorias[0]),
//   ])
// }

export const listarProjetos = e => {
  return dispatch => {
    // api.get(`/Projetos/${e}`)
    console.error('PASSO1');
    //apiOld.get(`/Usuario/${e}`)
    apiV3.get(`/Usuario/V3/${e}`)
    .then(result => {
      const projetoinsv = JSON.parse(localStorage.getItem('projetoINSV'))
      //console.error('PASSO2');
      //const projetoUsefy = projetoinsv?.id ? projetoinsv : result.data.projetos[0]
      const projetoUsefy = result.data.informacoesProjetos[0];
      //const projetoUsefy = result.data.projetos;
      //console.error('PASSO3');
      //console.error(projetoUsefy, 'PROJETO-USEFY:');
      const cicloReturn = projetoUsefy.ciclos.map(c=> cicloIntervalo(c))
      //console.error('PASSO4');
      const respGrupos = projetoUsefy.grupos.map((g, i)=> ({id: i, name: g.nomeGrupo?g.nomeGrupo:'grupo', ...g}))
      //console.error('PASSO5');
      //console.error('PARAMETRO E' + e);
      //console.error('GRUPOS LIDOS DE ZERO' + respGrupos[0]);
      //console.error(respGrupos, 'RESPGRUPOS LIDO:');
      //console.error(grupos, 'GRUPOS LIDO:');
    console.warn(projetoUsefy, 'projetoUsefyprojetoUsefyprojetoUsefyprojetoUsefyprojetoUsefy');

      //console.log("AQUI CATEGORIAS!!!", result.data.categorias)
      dispatch([
        setListarProjetos(result.data.informacoesProjetos),
        setInfoProjeto(projetoUsefy),
        setListarEmpresas(projetoUsefy.empresas),
        setInfoEmpresa(projetoUsefy.empresas[0]),
        setListarGrupos(respGrupos),
        setInfoGrupo(respGrupos[0]),
        setListarCiclos(cicloReturn),
        setInfoCiclo(cicloReturn[0]),
        
        setListarCategorias(result.data.categorias),

        setFiltersHas({name: 'ciclo', value: cicloReturn[cicloReturn.length - 1]})
      ])
      
      console.error('PASSO6');
    })
    .catch(err => {
        console.error(err, 'listarProjetos');
        // dispatch(logOut())
    });
  }
}

export const listarGrupos = e => {
  return dispatch => {
    console.error('PASSO1A');
    api.get(`/Grupos${''}`)
    .then(result => {
      console.error('PASSO2A');
      const respGrupos = result.data.map((g, i)=> ({id: i, name: g.nomeGrupo?g.nomeGrupo:'grupo', ...g}))
      console.error('PASSO31A');
      dispatch(setListarGrupos(respGrupos))
      console.error('PASSO4A');
    })
    .catch(err => {
        console.error(err, 'listarProjetos');
    });
  }
}

const setLogIn = e => ({
  type: 'LOG_IN',
  payload: e
})


export const logIn = (credentials, nls, nextPage = null) => {
  return async dispatch => {
    dispatch(loading())

    const params = {
      email: credentials.email,
      password: credentials.senha
    }

    try {
      const response = await apiAuth.post(`/Auth/Login`, params)

      if (response.data.isSuccess) {
        localStorage.setItem('tolkenINSV', `Bearer ${response.data.message}`)
        
        await dispatch(logUserNew(credentials, response.data, nextPage))

      } else {
        dispatch([setLogIn(false), loaded()])
      }

    } catch (error) {
      const errorId = error?.response?.data?.errorId

      if (errorId === 704) {
        dispatch([
          AddAlert('danger', nls.mensagem.confirmeseuemailparalogin),
          setLogIn(false),
          loaded()
        ])
        return
      }

      dispatch([
        AddAlert('danger', nls.mensagem.emailousenhainvalidos),
        setLogIn(false),
        loaded()
      ])
    }
  }
}



export const logInOLD = (credentials, nls, nextPage = null) => {
  return async dispatch => {
    dispatch(loading())
    const params = {
      email: credentials.email,
      password: credentials.senha
    }

    try {
      const response = await apiAuth.post(`/Auth/Login`, params)
      console.error(response.data, 'response.dataresponse.dataresponse.dataresponse.data');
      
      if (response.data.isSuccess) {
        localStorage.setItem('tolkenINSV', `Bearer ${response.data.message}`)
        
        // Dispara a ação logUserNew com o nextPage
        await dispatch(logUserNew(credentials, response.data, nextPage))
        
        // Adiciona alerta de sucesso
        //dispatch(AddAlert('success', nls.mensagem.loginsucesso))
      } else {
        dispatch([setLogIn(false), loaded()])
        //dispatch(AddAlert('danger', nls.mensagem.emailousenhainvalidos))
      }
    } catch (error) {
      dispatch([
        AddAlert('danger', nls.mensagem.emailousenhainvalidos),
        setLogIn(false), 
        loaded()
      ])
    }
  }
}

/*
export const logInOLD = (e,nls) => {
  return async dispatch => {
    dispatch(loading())
    const params = {
      email: e.email,
      password: e.senha
    }

    await apiAuth.post(`/Auth/Login`, params)
    .then(response => {
      console.error(response.data, 'response.dataresponse.dataresponse.dataresponse.data');
      
      if (response.data.isSuccess) {
        localStorage.setItem('tolkenINSV', `Bearer ${response.data.message}`)
        // dispatch([logUser(e.email)])
        setTimeout(() => {
          dispatch([logUserNew(e, response.data)])
        }, 3000);
      } else {
        dispatch([setLogIn(false), loaded()])
      }
    })
    .catch(error => {
      dispatch([
        AddAlert('danger', nls.mensagem.emailousenhainvalidos),
        setLogIn(false), 
        loaded()
      ])
    })
  }
}

*/


export const logUser = e => {
  return dispatch => {
    //apiOld.get(`/Usuario/${e}`)
    apiV3.get(`/Usuario/V3/${e}`)
    //apiV3.get(`/Usuario/${e}`)
    .then(response => {
      dispatch(logUserNew(response.data))
    })
    .catch(error => {
      console.error(error, 'logUser error');
      dispatch(loaded())
    })
  }
}


export const logUserNew = (credentials, login, nextPage = null) => {
  return async dispatch => {
    try {
      const response = await api.get(`/Usuario/InformaMeusDadosCadastro`)
      const infoUser = response.data
      
      dispatch([
        setLogIn(true),
      ])
      
      localStorage.setItem('projetosINSV', JSON.stringify(infoUser.projetos))
      
      await dispatch(informacoesLogin())
      
      // Chama logedPermissoes com o nextPage
      await dispatch(logedPermissoes(infoUser, login.permissoes, login.primeiroLogin, nextPage))
    } catch (error) {
      console.error(error, 'logUser error')
      dispatch(loaded())
    }
  }
}



export const logUserNewOLD = (e, login) => {
  return async dispatch => {
    await api.get(`/Usuario/InformaMeusDadosCadastro`)
    .then(response => {
      // const infoUser = {...e, ...response.data}
      const infoUser = response.data
      //console.error(response.data,'INFORMAMEUSDADOSCADASTRO')
      
        dispatch([
          setLogIn(true),
          // listarMeusProjetos(e.projetos),
          // setListarProjetos(e.projetos),
          // loaded(),
        ])
        localStorage.setItem('projetosINSV', JSON.stringify(e.projetos))
        
        dispatch(informacoesLogin())
        dispatch(logedPermissoes(infoUser, e.permissoes, login.primeiroLogin))
    })
    .catch(error => {
      console.error(error, 'logUser error');
      dispatch(loaded())
    })
  }
}

export const loged = e => {
  const user = localStorage.getItem('userINSV')
  const usuario = JSON.parse(user)
  // const projects = localStorage.getItem('projetosINSV')
  // const projetos = JSON.parse(projects)
  console.error(usuario, 'loged');
  
  return dispatch => {
    if (user) {
      dispatch([
        setLogIn(true),
        setCarregarUsuarioLogado(usuario),
        informacoesLogin(),
        // setListarProjetos(projetos),
        getSistemaIdioma(idiomaString(usuario.idioma.nome)),
        getSistema({name: 'moeda', value: idiomaString(usuario.moedaIso4217)}),
        getSistema({name: 'idiomaIdValue', value: usuario.idioma.id}),
        getSistema({name: 'idiomaIdValueGet', value: usuario.idioma.id}),
      ])
    } else {
      dispatch(logOut())
    }
  }
}




export const informacoesLogin = e => {
  return async dispatch => {
    await api.get(`/Usuario/InformacoesLogin`)
    .then(response => {
      //console.log("INFOLOGINPERFIL", response.data.perfil.name)
      dispatch([
        getSistema({name: 'login', value: response.data}),
        getSistema({name: 'idiomaIdValue', value: response.data.idioma.id}),
        getSistema({name: 'idioma', value: idiomaString(response.data?.idioma?.nome)}),
        getSistema({name: 'dataAtualizacaoAssinatura', value: response.data.dataAtualizacaoAssinatura}),
        getNotificacoes(response.data.notificacoes)
      ])
    })
    .catch(error => {
      console.error(error, 'logUser error');
    })
  }
}



export const logedPermissoes = (infoUser, permissoes, primeiroLogin, nextPage = null) => {
  return async dispatch => {
    try {
      // 1. Primeiro obtemos as permissões
      const permissoesResponse = await api.get(`/Usuario/PermissoesUsuarios`);
      const permissoesUsuario = permissoesResponse.data.reduce((a, v) => ({ ...a, [v.tipo]: v.status}), {});
      const infoUserCompleto = {...infoUser, permissoes: permissoesUsuario};

      dispatch(setCarregarUsuarioLogado(infoUserCompleto));
      localStorage.setItem('userINSV', JSON.stringify(infoUserCompleto));
      localStorage.setItem('userPermissionsINSV', JSON.stringify(permissoesUsuario));

      // 2. Lógica de redirecionamento
      if (primeiroLogin) {
        history.push('/questionnaire');
      } else if (nextPage === '1') {
        // Se tem nextpage=1, verificamos o tipoContaId
        try {
          const dadosCadastroResponse = await api.get(`/Usuario/InformaMeusDadosCadastro`);
          const tipoContaId = dadosCadastroResponse.data.tipoContaId;
          
          // Só redireciona para accountupgrade se tipoContaId for 2
          if (tipoContaId === 2) {
            history.push('/accountupgrade');
          } else {
            // Se não for tipoContaId 2, segue fluxo normal
            history.push('/myprojects');
          }
        } catch (error) {
          console.error('Erro ao obter dados do cadastro:', error);
          // Em caso de erro, segue fluxo normal
          history.push('/myprojects');
        }
      } 
      else if (nextPage === '2') {
        // Novo caso para nextpage=2 - redireciona para projectstore
        history.push('/projects');
      }    
      else if (permissoes !== null && !(permissoes && Object.keys(permissoes).length)) {
        // Redirecionamento padrão para myprojects
        history.push('/myprojects');
      }

      setTimeout(() => {
        dispatch(loaded());
      }, 3000);
    } catch (error) {
      console.error(error, 'logUser error');
      dispatch([loaded()]);
    }
  };
};



export const logedPermissoesOLD = (e, permissoes, primeiroLogin) => {
  return async dispatch => {
    await api.get(`/Usuario/PermissoesUsuarios`)
    .then(response => {
      const infoUser = {...e, permissoes: response.data.reduce((a, v) => ({ ...a, [v.tipo]: v.status}), {})}

      dispatch(setCarregarUsuarioLogado(infoUser))
      localStorage.setItem('userINSV', JSON.stringify(infoUser))
      localStorage.setItem('userPermissionsINSV', JSON.stringify(infoUser.permissoes))

      if(primeiroLogin){
        //history.push('/questionario')
        history.push('/questionnaire')
      } else if (permissoes !== null && !(permissoes && Object.keys(permissoes).length)) {
        setTimeout(() => {
          //history.push('/meusprojetos')
          history.push('/myprojects')
        }, 3000);
      }

      setTimeout(() => {
        dispatch(loaded())
      }, 3000);
    })
    .catch(error => {
      console.error(error, 'logUser error');
      dispatch([
        loaded(),
      ])
    })
  }
}

export const logOut = e => {

  localStorage.clear()
  return dispatch => {
    dispatch([
      setLogIn(false), 
      modalOpen(''),  
      setCarregarUsuarioLogado({})
    ])
    history.push('/')

    // Força um refresh após o redirecionamento para remover o ícone do Jivochat
    setTimeout(() => {
      window.location.reload();
    }, 100);

  }
}

export const recuperarSenha = e => {
  return dispatch => {
    api
      .put(`/usuario/recuperarSenha/${e.email}`)
      .then(response => {
        dispatch([
          AddAlert('success', 'Senha enviada para o seu e-mail'),
          history.goBack()
        ])
      })
      .catch(error => {
        dispatch([setLogIn(false), AddAlert('error', nls.mensagem[error.request.response])])
      })
  }
}



export const setListasData = payload => ({
  type: 'SET_LISTAS_DATA',
  payload
})

export const setShowNotificacoes = payload => ({
  type: 'SET_SHOW_NOTIFICACOES',
  payload
})

export const getNotificacoes = payload => ({
  type: 'GET_NOTIFICACOES',
  payload
})

export const deleteNotificacoes = payload => ({
  type: 'DELETE_NOTIFICACOES',
  payload
})

export const deleteNotificacao = payload => ({
  type: 'DELETE_NOTIFICACAO',
  payload
})

export const listarNotificacoes = e => {
  const notificacoes = [
    {
      id:'1',
      titulo: 'Erro no registro da Empresa 1',
      conteudo: 'Nosso sistema detectou um erro na validação do link para o registro do Facebook.',
      data: new Date().toISOString()
    },
    {
      id:'2',
      titulo: 'Erro no registro da Empresa 3',
      conteudo: 'Nosso sistema detectou um erro na validação do link para o registro do Facebook.',
      data: new Date().toISOString()
    }
  ]
  return dispatch => {
    dispatch(getNotificacoes(notificacoes))
  }
}

export const listarEstados = e => {
  const listaEstados = listasJson.estados.find(estado=> estado.id === e.id)
  return dispatch => {
    dispatch(setListasData({name: 'estados', value: listaEstados.lista}))
  }
}

export const listarCidades = e => {
  const listaCidades = listasJson.cidades.find(cidade=> cidade.id === e.id)
  return dispatch => {
    dispatch(setListasData({name: 'cidades', value: listaCidades.lista}))
  }
}

export const getIp = e => {
  return dispatch => {
    apiIp.get(`/getip/Ip`)
    .then(response => {
      
      dispatch([
        getSistema({name: 'getip', value: response.data}),
        listarPaises(response.data),
        listarSegmentos(response.data),
        getSistemaIdioma(idiomaString(response.data.idioma)),
        getSistema({name: 'moeda', value: idiomaString(response.data.moeda)}),
        getSistema({name: 'idiomaIdValue', value: response.data.idiomaId}),
        getSistema({name: 'idiomaIdValueGet', value: response.data.idiomaId}),
        getSistema({name: 'idioma', value: idiomaString(response.data?.idioma)}),
        // getSistema({name: 'pais', value: paisId})
        // listarIdiomas(response.data)
      ]) 
      
    })
    .catch(error => {
      console.error(error, 'error getIp');
      const ip = {
        "countrycode": "BR",
        "countryname": "Brazil",
        "region": "SP",
        "city": "São Paulo",
        "idiomaId": 2,
        "errmsg": null,
        "idioma": "en",
        "ipaddress": "000.000.00.000",
        "moeda": "usd",
        "paisId": 51
      }
      
      dispatch([
        getSistema({name: 'getip', value: ip}),
        listarPaises(ip),
        listarSegmentos(ip),
        getSistema({name: 'idioma', value: idiomaString(ip.idioma)}),
        getSistemaIdioma(idiomaString(ip.idioma)),
        getSistema({name: 'moeda', value: idiomaString(ip.moeda)}),
        getSistema({name: 'idiomaIdValue', value: ip.idiomaId}),
        getSistema({name: 'idiomaIdValueGet', value: ip.idiomaId}),
      ])
    })
  }
}

export const listarPaises = e => {
  // const params = paramsApi(e)
  return dispatch => {
    api.get(`/Pais/ListaPaises`, {headers:{SenhaAuthorization: `${process.env.REACT_APP_INSV_SENHA_API}`}})
    .then(response => {
      let paisesIdiomaResult = {}
      response.data.map(s=> {
        paisesIdiomaResult = {...paisesIdiomaResult, [s.nome]: s.paises}
      })
      const paisesResult = response.data.find(s=> s.nome.toUpperCase() === e.idioma.toUpperCase())
      dispatch([
        setListasData({name: 'paises', value: paisesResult.paises}),
        setListasData({name: 'paisesIdiomas', value: paisesIdiomaResult}),
      ])
      console.error(paisesResult, paisesIdiomaResult, e, 'paisesResultpaisesResultpaisesResultpaisesResult');
      if (e.paisId) {
        const paisSelected = paisesResult.paises.find(p=> p.idPais === e.paisId)
        dispatch([
          getSistema({name: 'pais', value: paisSelected}),
          setProjetosFiltro({name: 'paises', value: paisSelected}),
        ])
      }
    })
    .catch(error => {
      console.error(error, 'error listarPaises');
      dispatch(setListasData({name: 'paises', value: listasJson.paises}))
    })
  }
}

export const listarSegmentos = e => {
  return dispatch => {
    api.get(`/Idioma/ListaSegmentos`, {headers:{SenhaAuthorization: `${process.env.REACT_APP_INSV_SENHA_API}`}})
    .then(response => {
      let segmentoIdiomaResult = {}
      response.data.map(s=> {
        segmentoIdiomaResult = {...segmentoIdiomaResult, [s.idioma.idioma]: s.segmentos}
      })
      const segmentoResult = response.data.find(s=> s.idioma.idioma === e.idioma)
      dispatch([
        setListasData({name: 'segmentos', value: segmentoResult.segmentos}),
        setListasData({name: 'segmentosIdiomas', value: segmentoIdiomaResult}),
      ])     
      console.error(segmentoResult, segmentoIdiomaResult, e, 'segmentoIdiomaResultsegmentoIdiomaResultsegmentoIdiomaResultsegmentoIdiomaResultsegmentoIdiomaResult');
      if (e.paisId) {
        const segmentoSelected = segmentoResult.segmentos[0]
        dispatch([
          setProjetosFiltro({name: 'segmentos', value: segmentoSelected}),
        ])
      }
    })
    .catch(error => {
      console.error(error, 'error listarSegmentos');
    })
  }
}


export const listarIdiomas = e => {
  return dispatch => {
    api.get(`/Idioma/ListaIdiomas`)
    .then(response => {
        const idiomaSplit = e.idioma.split('-')
        const idioma = idiomaSplit.length>1?e.idioma.replace(idiomaSplit[1], idiomaSplit[1].toUpperCase()): e.idioma
      dispatch([
        getSistema({name: 'idioma', value: idioma}),
        getSistema({name: 'idiomas', value: response.data}),
      ])
    })
    .catch(error => {
      console.error(error, 'error listarIdiomas');
    })
  }
}



export const informeNaoMostrar = e => {
  return dispatch => {
    api.post(`/Usuario/RegistraNaoReceberBoasVindas`)
    .then(response => {
      console.warn(response, 'response informeNaoMostrar');
    })
    .catch(error => {
      console.error(error, 'error informeNaoMostrar');
    })
  }
}

export const userVisualizouNotificacoes = e => {
  return dispatch => {
    api.put(`/Usuario/RegistraVisualizouNotificacoes`)
    .then(response => {
      console.warn(response, 'response userVisualizouNotificacoes');
    })
    .catch(error => {
      console.error(error, 'error userVisualizouNotificacoes');
    })
  }
}

export const apagarNotificacao = e => {
  console.warn(e, 'apagarNotificacao');
  let params = []
  e.map(f=> {
    params = [...params, (f.idNotificao)]
  })
  return dispatch => {
    api.put(`/Usuario/RegistraApagarNotificacao`, params)
    .then(response => {
      if (params.length === 1) {
        dispatch(deleteNotificacao(params[0]))
      } else {
        dispatch(deleteNotificacoes())
      }
    })
    .catch(error => {
      console.error(error, 'error apagarNotificacao');
    })
  }
}



export const verificaConsumoConta = e => {
  return (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)

    api.get(`/Usuario/VerificaConsumoConta`)
    .then(response => {
      dispatch(getSistema({name: 'consumoConta', value: response.data}))
    })
    .catch(error => {
      console.error(error, 'error verificaConsumoConta');
      if (error.response.data.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login')
              dispatch(modalAlertaClean())
            },
            btnClose: () => {
              history.push('/login')
              dispatch(modalAlertaClean())
            },
          })
        )
      }
    })
  }
}



export const verificaCreditoConta = () => {
  return async (dispatch, getState) => {
    //console.trace('verificaCreditoConta disparado');
    const { sistema } = getState().layoutState;
    const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`);

    try {
      const response = await api.get(`/Usuario/VerificaCreditosConta`);

      dispatch(getSistema({
        name: 'creditoConta',
        value: response.data
      }));
    } catch (error) {
      console.error('Erro em verificaCreditoConta:', error);

      if (error.response?.data?.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
            btnClose: () => {
              history.push('/login');
              dispatch(modalAlertaClean());
            },
          })
        );
      }
    }
  };
};


//Não estava correta para funcionar com await na chamada de PosCheckOutXD
export const verificaCreditoContaOLD = e => {
  return (dispatch, getState) => {
    const { sistema } = getState().layoutState
    const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)

    api.get(`/Usuario/VerificaCreditosConta`)
    .then(response => {
      dispatch(getSistema({name: 'creditoConta', value: response.data}))
    })
    .catch(error => {
      console.error(error, 'error verificaCreditoConta');
      if (error.response.data.iderro === 999) {
        dispatch(
          modalAlertaInfo({
            ...nlsPopup[29],
            show: true,
            btnAction: () => {
              history.push('/login')
              dispatch(modalAlertaClean())
            },
            btnClose: () => {
              history.push('/login')
              dispatch(modalAlertaClean())
            },
          })
        )
      }
    })
  }
}


//Precisa testar
export const PosCheckOutXD = (e) => {
  return async (dispatch) => {
    try {
      // 1. Aguarda SOMENTE a conclusão do PosCheckOutXD
      const response = await apiBase.get(`/v4/api/PosCheckOutXD?session_id=${e}`);
      
      const userInsv = JSON.parse(localStorage.userINSV || "{}");
      console.log("PosCheckOutXD concluído", response.data);

      // 2. Dispara as outras ações em série: coloqueui wait e mudei a ordem: ceiricaCreditoConta por último
      
      await dispatch(logedPermissoes(userInsv, null, false));
      await dispatch(listarMeusProjetos());
      await dispatch(verificaCreditoConta());

      return response.data;
    } catch (error) {
      console.error("Erro no PosCheckOutXD:", error);
      return null;
    }
  };
};



//Roda tudo em paralelo e não funciona. Precisa esperar PosCheckOutXD terminar.
export const PosCheckOutXDOLD = e => {
  return dispatch => {
    return apiBase.get(`/v4/api/PosCheckOutXD?session_id=${e}`) // 👈 retorno da Promise
      .then(response => {
        const userInsvString = localStorage.userINSV
        const userInsv = JSON.parse(userInsvString)
        console.error(response, userInsv, 'PosCheckOutXD');

        dispatch([
          verificaCreditoConta(),
          logedPermissoes(userInsv, null, false),
          listarMeusProjetos(),
        ]);

        console.log("GTM LIDO", response.data);
        return response.data; // 👈 esse será acessado no `.then()` do componente
      })
      .catch(error => {
        console.error(error, 'error verificaCreditoConta');
        return null;
      });
  };
};


export const PortalClienteXD = e => {
  return dispatch => {
    dispatch(loading())
    apiBase.get(`/v4/api/PortalClienteXD?urlVoltaDoPortal=${e}`)
    .then(({data}) => {
      console.log(data, 'PortalClienteXD');
      window.location.href = data.urlPortal
    })
    .catch(error => {
      console.error(error, 'error PortalClienteXD');
    })
    .finally(()=> {
      dispatch(loaded())
    })
  }
}